/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
// Packages
import React, {
	useState,
	useReducer,
	useEffect,
	useContext,
	useCallback,
} from 'react'
import ApolloClient, { gql } from 'apollo-boost'
import { ApolloProvider, Query, useMutation } from 'react-apollo'
import dayjs from 'dayjs'
import _lang from 'lodash/lang'
import { Link } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import moment from 'moment'
import {
	EditOutlined,
	SearchOutlined,
	EyeOutlined,
	EyeInvisibleOutlined,
	RetweetOutlined,
	MailTwoTone,
	PhoneTwoTone,
	MobileOutlined,
	ChromeOutlined,
	BarChartOutlined,
	DesktopOutlined,
} from '@ant-design/icons'

// Styles
import {
	Row,
	Col,
	Button,
	Table,
	Tabs,
	Popover,
	Modal,
	Tooltip,
	message,
	Badge,
	Spin,
	Select,
	Input,
	Tag,
} from 'antd'
// Dependencies
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)
// For antd
const { Column } = Table
const { TabPane } = Tabs
const { Option } = Select

// {eventID: {_is_null: true}}

const queryActiveJob = gql`
  query getActiveJobs(
    $limit: Int
    $offset: Int
    $search: String
    $selectedCoyId: [Int!]
    $id: Int
  ) {
    Job_aggregate(
      where: {
        _and: [
          { isAvailable: { _eq: true } }
          { jobPostStart: { _lte: "now()" } }
          {
            _or: [
              {
                _and: [
                  { jobPostEnd: { _gte: "now()" } }
                  { JobPlatforms: { platform: { _eq: "REGULAR" } } }
                ]
              }
              { JobPlatforms: { platform: { _eq: "NTUC" } } }
            ]
          }
          { title: { _ilike: $search } }
          { id: { _eq: $id } }
          { Company: { id: { _in: $selectedCoyId } } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    Job(
      limit: $limit
      offset: $offset
      order_by: { updatedAt: desc }
      where: {
        _and: [
          { isAvailable: { _eq: true } }
          { jobPostStart: { _lte: "now()" } }
          {
            _or: [
              {
                _and: [
                  { jobPostEnd: { _gte: "now()" } }
                  { JobPlatforms: { platform: { _eq: "REGULAR" } } }
                ]
              }
              { JobPlatforms: { platform: { _eq: "NTUC" } } }
            ]
          }
          { title: { _ilike: $search } }
          { id: { _eq: $id } }
          { Company: { id: { _in: $selectedCoyId } } }
        ]
      }
    ) {
      description
      id
      jobPostEnd
      jobPostStart
      requirements
      title
      isAvailable
      updatedAt
      JobApplicants_aggregate {
        aggregate {
          count(columns: applicant)
        }
      }
      JobSalaries {
        id
        min
        max
        jobType
      }
      Company {
        id
        name
      }
      User {
        id
        name
      }
      JobPlatforms {
        platform
      }
      JobViews {
        source
        medium
        campaign
        count
      }
      JobImpressions {
        source
        medium
        campaign
        count
      }
    }
  }
`

const queryInactiveJob = gql`
  query getInactiveJobs(
    $limit: Int
    $offset: Int
    $search: String
    $selectedCoyId: [Int!]
    $platformArr: [String!]!
    $id: Int
  ) {
    Job_aggregate(
      where: {
        _and: [
          { JobPlatforms: { platform: { _in: $platformArr } } }
          { title: { _ilike: $search } }
          { id: { _eq: $id } }
          { Company: { id: { _in: $selectedCoyId } } }
        ]
        _or: [
          { isAvailable: { _eq: false } }
          { jobPostStart: { _gt: "now()" } }
          {
            _and: [
              { jobPostEnd: { _lte: "now()" } }
              { JobPlatforms: { platform: { _eq: "REGULAR" } } }
            ]
          }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
    Job(
      limit: $limit
      offset: $offset
      order_by: { updatedAt: desc }
      where: {
        _and: [
          { JobPlatforms: { platform: { _in: $platformArr } } }
          { title: { _ilike: $search } }
          { id: { _eq: $id } }
          { Company: { id: { _in: $selectedCoyId } } }
        ]
        _or: [
          { isAvailable: { _eq: false } }
          { jobPostStart: { _gt: "now()" } }
          {
            _and: [
              { jobPostEnd: { _lte: "now()" } }
              { JobPlatforms: { platform: { _eq: "REGULAR" } } }
            ]
          }
        ]
      }
    ) {
      id
      title
      requirements
      description
      jobPostStart
      jobPostEnd
      isAvailable
      updatedAt
      JobApplicants_aggregate {
        aggregate {
          count(columns: applicant)
        }
      }
      JobSalaries {
        id
        min
        max
        jobType
      }
      Company {
        id
        name
      }
      User {
        id
        name
      }
      JobPlatforms {
        platform
      }
      JobViews {
        source
        medium
        campaign
        count
      }
      JobImpressions {
        source
        medium
        campaign
        count
      }
    }
  }
`

const nFormatter = (num, digits = 1) => {
	const lookup = [
		{ value: 1, symbol: '' },
		{ value: 1e3, symbol: 'k' },
		{ value: 1e6, symbol: 'M' },
		{ value: 1e9, symbol: 'G' },
		{ value: 1e12, symbol: 'T' },
		{ value: 1e15, symbol: 'P' },
		{ value: 1e18, symbol: 'E' },
	]
	const rx = /\.0+$|(\.[0-9]*[1-9])0+$/
	const item = lookup
		.slice()
		.reverse()
		.find(function (item) {
			return num >= item.value
		})
	return item
		? (num / item.value).toFixed(digits).replace(rx, '$1') + item.symbol
		: '0'
}

const JobList = () => {
	const [coyName, setCoyNames] = useState([])
	const [activeTotal, setActiveTotal] = useState(0)
	const [inactiveTotal, setInactiveTotal] = useState(0)
	const [isActive, setIsActive] = useState(
		localStorage.getItem('isActive')
			? JSON.parse(localStorage.getItem('isActive') ?? '')
			: true
	)
	const [selectedCoyId, setSelectedCoyId] = useState(
		localStorage.getItem('jobListSelectedCoyId')
			? JSON.parse(localStorage.getItem('jobListSelectedCoyId') ?? '')
			: []
	)
	const [searchInputs, setSearchInputs] = useState(
		localStorage.getItem('jobListSearchInputs')
			? JSON.parse(localStorage.getItem('jobListSearchInputs') ?? '')
			: {
				title: '',
			}
	)

	// for <Badge />
	const [activeCount, setActiveCount] = useState(0)
	const [inactiveCount, setInactiveCount] = useState(0)
	const [isUnauthorised] = useState(false)
	const [isModalVisible, setIsModalVisible] = useState(false)
	const initialActiveState = localStorage.getItem('jobPageProp')
		? JSON.parse(localStorage.getItem('jobPageProp') ?? '')
		: {
			current: 0,
			limit: 10,
		}
	const initialInactiveState = localStorage.getItem('jobPageProp')
		? JSON.parse(localStorage.getItem('jobPageProp') ?? '')
		: {
			current: 0,
			limit: 10,
		}

	const reducer = (state, action) => {
		switch (action.type) {
		case 'offset':
			return {
				current: action.payload.page ? action.payload.page - 1 : 0,
				limit: action.payload.limit ? action.payload.limit : state.limit,
			}
		case 'reset':
			return action.payload
		default:
			throw new Error()
		}
	}
	const [state, dispatch] = useReducer(
		reducer,
		isActive ? initialActiveState : initialInactiveState
	)

	const platformArr = ['REGULAR', 'NTUC']

	const Client = new ApolloClient({
		uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
		headers: {
			'X-Hasura-Admin-Secret': process.env.REACT_APP_HASURA_SECRET
		}
	})

	const getCoyNames = useCallback(() => {
		Client.query({
			query: gql`
				query {
					Company(order_by: {name: asc}) {
						id
						name
					}
				}
			`,
		})
			.then(({ data: { Company } }) => {
				if (Company) setCoyNames(Company)
				else return null
			})
			.catch((err) => console.error(err))
	}, [])

	useEffect(() => {
		if (coyName.length === 0) getCoyNames()
		localStorage.setItem('jobListSearchInputs', JSON.stringify(searchInputs))
		localStorage.setItem('jobListSelectedCoyId', JSON.stringify(selectedCoyId))
		localStorage.setItem('isActive', JSON.stringify(isActive))
		localStorage.setItem('jobPageProp', JSON.stringify(state))
		window.sessionStorage.removeItem('applicantsListPageProps')
		// eslint-disable-next-line
	}, [getCoyNames, searchInputs, selectedCoyId, isActive, state]);

	const onSearchChange = (e) => {
		const { name, value } = e.target
		if (name === 'searchCoyName') {
			setSearchInputs({
				...searchInputs,
				coyName: value,
			})
		} else {
			setSearchInputs({
				...searchInputs,
				title: value,
			})
		}
		dispatch({ type: 'reset', payload: { current: 0, limit: state.limit } })
	}

	// <Switch /> for Activating/De-Activating Job(s)
	// Activating Job require setting more Columns
	const ShowOptions = ({ job: { id, isAvailable, title } }) => {
		const UPDATE_IS_AVAILABLE = gql`
      mutation ($id: Int!, $availability: Boolean!, $postEndDate: timestamptz) {
        update_Job(
          where: { id: { _eq: $id } }
          _set: { isAvailable: $availability, jobPostEnd: $postEndDate }
        ) {
          affected_rows
        }
      }
    `
		const [updateIsAvailable] = useMutation(UPDATE_IS_AVAILABLE)
		return (
			<Tooltip
				title={
					isAvailable ? 'Disable job' : 'Enable job'
				}
			>
				<Button
					icon={isAvailable ? <EyeInvisibleOutlined /> : <EyeOutlined />}
					onClick={() => {
						updateIsAvailable({
							variables: {
								id,
								availability: !isAvailable,
								postEndDate: isAvailable
									? moment().format()
									: moment().add(3, 'M').format(),
							},
							refetchQueries: isAvailable
								? ['getActiveJobs']
								: ['getInactiveJobs'],
						})
						if (isAvailable) {
							message.success(`${title} set to Inactive`)
							setInactiveCount(inactiveCount + 1)
						} else {
							message.success(`${title} set to Active`)
							setActiveCount(activeCount + 1)
						}
					}}
				/>
			</Tooltip>
		)
	}

	// The entire <Table /> that lists Active/Inactive Job(s)
	const ShowJobs = ({ isActive }) => {
		// Modal
		const RepostOrActivate = ({ job }) => {
			const { JobSalaries } = job

			const [visibility, setVisibility] = useState(false)

			const UPDATE_UPDATEDAT = gql`
        mutation ($jobId: Int!, $currentTimestamp: timestamptz!) {
          update_Job(
            where: { id: { _eq: $jobId } }
            _set: {
              updatedAt: $currentTimestamp
              jobPostStart: $currentTimestamp
            }
          ) {
            affected_rows
          }
        }
      `

			const [updatedUpdatedAt] = useMutation(UPDATE_UPDATEDAT, {
				onCompleted() {
					message.success('Job Successfully Reposted')
				},
				// ,
				// onError () {
				//   message.error('An Error Occured')
				// }
			})

			const jobPostEndMessage = () => {
				const retrievedTimestamp = job.jobPostEnd
				if (retrievedTimestamp) {
					if (new Date(retrievedTimestamp) < new Date())
						return 'This Job Post has Expired'
					else
						return `This Job Post will expire on ${dayjs(job.jobPostEnd).format(
							'D MMM YYYY'
						)}`
				} else return 'This Job Post has no expiry date'
			}

			const noJobSalaries = () => {
				if (JobSalaries.length) {
					return false
				}
				return true
			}

			const showModal = () => {
				setVisibility(true)
			}

			const handleOk = () => {
				const now = moment().format()

				updatedUpdatedAt({
					variables: {
						jobId: job.id,
						currentTimestamp: now,
					},
					refetchQueries: ['getActiveJobs'],
				})

				setVisibility(false)
			}

			const handleCancel = () => {
				setVisibility(false)
			}

			const repostButtonPropsCheck = () => {
				let isJobPostExpired
				if (job.jobPostEnd) {
					isJobPostExpired = new Date(job.jobPostEnd) < new Date()
				}
				if (!job.isAvailable || isJobPostExpired) {
					return true
				} else return false
			}

			return (
				<>
					{/* Repost */}
					<Tooltip title="Repost">
						<Button
							icon={<RetweetOutlined />}
							onClick={showModal}
							disabled={repostButtonPropsCheck()}
						/>
					</Tooltip>
					<Modal
						visible={visibility}
						onOk={handleOk}
						onCancel={handleCancel}
						okText={'Repost'}
						okButtonProps={{ disabled: noJobSalaries() }}
					>
						<div style={{ textAlign: 'center' }}>
							<h2>You are about to repost</h2>
							<h4>
								{job.title} {'for'} {job.Company.name}
							</h4>
							<p>
								{jobPostEndMessage()}
								<br />
								{JobSalaries.length
									? ''
									: 'There are no Salaries stated for this Job'}
								<br />
								{/* Close this window and click on Edit to  */}
								{'Click on'}&nbsp;
								<HashLink
									to={{
										pathname: '/joblist/edit',
										hash: '#datepicker',
									}}
									state={{
										jobId: job.id,
										companyId: job.Company.id,
										companyName: job.Company.name,
										jobTitle: job.title,
									}}
								>
									{'Edit'}
								</HashLink>
                &nbsp;{'to amend the Job Post'}
							</p>
						</div>
					</Modal>
				</>
			)
		}

		return (
			<Query
				query={isActive ? queryActiveJob : queryInactiveJob}
				variables={{
					limit: state.limit,
					offset: state.limit * state.current,
					search: `%${searchInputs.title}%`,
					...(selectedCoyId.length > 0 && { selectedCoyId }),
					...(!isActive && {
						platformArr: [...platformArr, 'VCF'],
					}),
					...(isUnauthorised && { id: 0 }),
				}}
			>
				{({ loading, error, data, refetch }) => {
					if (loading)
						return (
							<div style={{ textAlign: 'center' }}>
								<Spin />
							</div>
						)
					if (error) return <div>Error</div>
					if (!_lang.isEmpty(data)) {
						const {
							Job_aggregate: {
								aggregate: { count },
							},
						} = data
						isActive ? setActiveTotal(count) : setInactiveTotal(count)
					}
					return (
						<div className="responsiveTable">
							<Button onClick={() => refetch()}>{'Refresh'}</Button>
							<Table
								dataSource={data.Job}
								rowKey="id"
								rowClassName="tableRow"
								loading={loading}
								scroll={{ x: true }}
								showHeader
								pagination={{
									current: state.current + 1,
									total: isActive ? activeTotal : inactiveTotal,
									pageSize: state.limit,
									showQuickJumper: true,
									pageSizeOptions: ['10', '30', '50', '100'],
									showSizeChanger: true,
									showTotal: (total, range) => {
										return `${range[0]}-${range[1]} of ${total} Jobs`
									},
									onChange: (page) => {
										dispatch({ type: 'offset', payload: { page: page } })
									},
									onShowSizeChange: (current, size) => {
										dispatch({
											type: 'offset',
											payload: { page: 1, limit: size },
										})
									},
								}}
							>
								<Column
									title={'Click on Job Title to view more'}
									key="id"
									render={(job) => {
										const jobPostEndMessage = () => {
											const retrievedTimestamp = job.jobPostEnd
											if (retrievedTimestamp) {
												if (new Date(retrievedTimestamp) < new Date()) {
													return `Expired on ${dayjs(job.jobPostEnd).format(
														'D MMM YYYY'
													)}`
												} else {
													return `Expires on ${dayjs(job.jobPostEnd).format(
														'D MMM YYYY'
													)}`
												}
											} else {
												return 'No Expiry Date'
											}
										}

										const ShowJobDescription = (
											<>
												<h3 style={{ marginBottom: '0px' }}>Description</h3>
												<Row style={{ color: '#677384' }}>
													<Col
														dangerouslySetInnerHTML={{
															__html: job.description,
														}}
													/>
												</Row>
												<br />
												<h3 style={{ marginBottom: '0px' }}>Salary</h3>
												{job.JobSalaries.length ? (
													<Row style={{ color: '#677384' }}>
														<Col>
															<div>
																{job.JobSalaries.map(
																	(js: {
                                    jobType: any;
                                    id: React.Key | null | undefined;
                                    min: string;
                                    max: string;
                                  }) => {
																		let type = ''
																		switch (js.jobType) {
																		case 'PT':
																			type = 'per hour'
																			break
																		case 'FT':
																			type = 'per month'
																			break
																		case 'DAILY':
																			type = 'Daily'
																			break
																		case 'WEEKLY':
																			type = 'Weekly'
																			break
																		default:
																			type = ''
																		}
																		return (
																			<div key={js.id}>
																				{'From $' +
                                          js.min +
                                          ' to $' +
                                          js.max +
                                          ' ' +
                                          type}
																			</div>
																		)
																	}
																)}
															</div>
														</Col>
													</Row>
												) : (
													''
												)}
												{job.User != null && (
													<>
														<br />
														<h3 style={{ marginBottom: '0px' }}>Created By</h3>
														<p>
															<strong>{job.User ? job.User.name : ''}</strong>
														</p>
													</>
												)}
											</>
										)

										// Impressions
										let mobileImpressions = 0
										let webImpressions = 0
										let kioskImpressions = 0
										for (const jv of job.JobImpressions) {
											if (jv.source === 'mobile') {
												mobileImpressions += jv.count
											}
											if (
												jv.source === 'web' ||
                        jv.source === 'google_jobs_apply'
											) {
												webImpressions += jv.count
											}
											if (jv.source === 'kiosk') {
												kioskImpressions += jv.count
											}
										}
										const totalImpressions =
                      mobileImpressions + webImpressions + kioskImpressions

										// Views
										let mobileViews = 0
										let webViews = 0
										let kioskViews = 0
										for (const jv of job.JobViews) {
											if (jv.source === 'mobile') {
												mobileViews += jv.count
											}
											if (
												jv.source === 'web' ||
                        jv.source === 'google_jobs_apply'
											) {
												webViews += jv.count
											}
											if (jv.source === 'kiosk') {
												kioskViews += jv.count
											}
										}
										const totalViews = mobileViews + webViews + kioskViews

										const ctr = Math.round(
											(totalViews / totalImpressions) * 100,
											2
										)

										const showImpressionsBreakdown = (
											<>
												{totalImpressions > 0 && (
													<Tooltip title="Total Impressions">
														<span style={{ marginRight: '30px' }}>
															<BarChartOutlined />{' '}
															{nFormatter(totalImpressions)}
														</span>
													</Tooltip>
												)}
												{mobileImpressions > 0 && (
													<Tooltip title="Mobile Impressions">
														<span style={{ marginRight: '30px' }}>
															<MobileOutlined /> {nFormatter(mobileImpressions)}
														</span>
													</Tooltip>
												)}
												{webImpressions > 0 && (
													<Tooltip title="Website Impressions">
														<span style={{ marginRight: '30px' }}>
															<ChromeOutlined /> {nFormatter(webImpressions)}
														</span>
													</Tooltip>
												)}
												{kioskImpressions > 0 && (
													<Tooltip title="Kiosk Impressions">
														<span>
															<DesktopOutlined /> {nFormatter(kioskImpressions)}
														</span>
													</Tooltip>
												)}
											</>
										)

										const showViewsBreakdown = (
											<>
												{totalViews > 0 && (
													<Tooltip title="Total Views">
														<span style={{ marginRight: '30px' }}>
															<BarChartOutlined /> {nFormatter(totalViews)}
														</span>
													</Tooltip>
												)}
												{mobileViews > 0 && (
													<Tooltip title="Mobile Views">
														<span style={{ marginRight: '30px' }}>
															<MobileOutlined /> {nFormatter(mobileViews)}
														</span>
													</Tooltip>
												)}
												{webViews > 0 && (
													<Tooltip title="Website Views">
														<span style={{ marginRight: '30px' }}>
															<ChromeOutlined /> {nFormatter(webViews)}
														</span>
													</Tooltip>
												)}
												{kioskViews > 0 && (
													<Tooltip title="Kiosk Views">
														<span>
															<DesktopOutlined /> {nFormatter(kioskViews)}
														</span>
													</Tooltip>
												)}
											</>
										)

										return (
											<>
												<Row>
													{/* View more... */}
													<Col>
														<h3 style={{ marginBottom: 0 }}>
															<Popover
																placement="bottom"
																title="Job Description"
																trigger="click"
																content={ShowJobDescription}
															>
																<span className="jobTitle">{job.title}</span>
															</Popover>
														</h3>
													</Col>
												</Row>
												{/* Displays jobPostStart/End date */}
												<Row style={{ color: '#677384' }}>
													{/* for Big Display */}
													<Col md={24} xs={0}>
														<p>
															<b>{job.Company.name}</b>
                              &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; Posted on{' '}
															<strong>
																{dayjs(job.jobPostStart).format('D MMM YYYY')}
															</strong>
                              &nbsp;
															{
																<>
                                  by{' '}
																	<strong>
																		{job.User ? job.User.name : ''}
																	</strong>
																</>
															}
                              &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
															{jobPostEndMessage()}
															{/* {isActive
                                ? `Expires on ${dayjs(job.jobPostEnd).format('D MMM YYYY')}`
                                : `Expired on ${dayjs(job.jobPostEnd).format('D MMM YYYY')}`} */}
														</p>
													</Col>

													{/* for Small Display */}
													<Col md={0} xs={24}>
														<p>
															<b>{job.Company.name}</b>
														</p>
													</Col>
													<Col md={0} xs={24}>
														<p>
															{'Posted on'}{' '}
															{dayjs(job.jobPostStart).format('D MMM YYYY')}
														</p>
													</Col>
													{
														<Col md={0} xs={24}>
															<p>
                                by{' '}
																<strong>{job.User ? job.User.name : ''}</strong>
															</p>
														</Col>
													}
													<Col md={0} xs={24}>
														<p>{jobPostEndMessage()}</p>
													</Col>
												</Row>
												<Row>
													<Col>
														<span
															style={{ fontSize: '12px', color: '#677384' }}
														>
															{'Updated at'}&nbsp;
															{dayjs(job.updatedAt).format('DD/MM/YYYY h:mm a')}
														</span>
													</Col>
												</Row>
												<Row>
													<Col>
														<div style={{ marginTop: '5px' }}>
															<Popover
																placement="bottom"
																title="Job Impressions"
																trigger="click"
																content={showImpressionsBreakdown}
															>
																<span
																	style={{
																		marginRight: '20px',
																		cursor: 'pointer',
																	}}
																>
                                  Total Impressions:{' '}
																	<strong>
																		{nFormatter(totalImpressions)}
																	</strong>
																</span>
															</Popover>
															<Popover
																placement="bottom"
																title="Job Views"
																trigger="click"
																content={showViewsBreakdown}
															>
																<span
																	style={{
																		marginRight: '20px',
																		cursor: 'pointer',
																	}}
																>
                                  Total Views:{' '}
																	<strong>{nFormatter(totalViews)}</strong>
																</span>
															</Popover>
															<Tooltip title="The number of click by jobseeker to view full job description either from job list or job recommendation!">
																<span style={{ marginRight: '20px' }}>
                                  Clickthrough rate: <strong>{_.isNaN(ctr) ? 0 : ctr}%</strong>
																</span>
															</Tooltip>
														</div>
													</Col>
												</Row>
											</>
										)
									}}
								/>
								<Column
									key="data.length"
									render={(job) => {
										const {
											JobApplicants_aggregate: {
												aggregate: { count },
											},
										} = job
										return (
											<>
												<Row
													type="flex"
													gutter={{ xs: 24, md: 8 }}
													justify="start"
												>
													{/* Button that displays num of Applicant(s) */}
													<Col style={{ marginBottom: '5px' }}>
														{count > 0 && (
															<Link
																to={{
																	pathname: '/joblist/applicantslist',
																}}
																state={{
																	job
																}}
															>
																<Tooltip title={'See Who Applied'}>
																	<Button
																		type="primary"
																		style={{ width: '160px' }}
																	>
																		{count}{' '}
																		{count > 1 ? 'Applicants' : 'Applicant'}
																	</Button>
																</Tooltip>
															</Link>
														)}
														{count === 0 && (
															<Button disabled style={{ width: '160px' }}>
																{'No Applicant'}
															</Button>
														)}
														{/* </Popover> */}
													</Col>

													{/* Edit Button */}
													<Col>
														<Link
															to={{
																pathname: '/joblist/edit',
																
															}}
															state={{
																jobId: job.id,
																companyId: job.Company.id,
																companyName: job.Company.name,
																jobTitle: job.title,
															}}
														>
															<Tooltip title={'Edit Job Post'}>
																<Button icon={<EditOutlined />} />
															</Tooltip>
														</Link>
													</Col>

													{/* Repost Button */}
													<Col>
														<RepostOrActivate job={job} />
													</Col>

													{/* <Switch /> */}
													<Col>
														<ShowOptions job={job} />
													</Col>
												</Row>
											</>
										)
									}}
								/>
							</Table>
						</div>
					)
				}}
			</Query>
		)
	}
	// pass through selected company ID
	const selectOption = (selectedOption) => {
		// assign selected company ID to array coyIds
		const coyIds = selectedOption
		// add selected company ID into coy array
		// ...- property spread notation
		setSelectedCoyId([...coyIds])
		dispatch({ type: 'reset', payload: { current: 0, limit: state.limit } })
	}

	const handleChangeTab = (key) => {
		if (key === '1') {
			setIsActive(true)
		} else {
			setIsActive(false)
		}
		dispatch({ type: 'reset', payload: { current: 0, limit: state.limit } })
	}

	return (
		<>
			<ApolloProvider client={Client}>
				<div className="jumbotron">
					{/* Job Title */}
					<h1>Job List</h1>
					<br />
					{/* link to create jobs */}
					<Link to={isUnauthorised ? {} : '/joblist/new'}>
						<Button
							type="primary"
							onClick={() => {
								if (isUnauthorised) setIsModalVisible(true)
							}}
						>
              Create New Job
						</Button>
					</Link>
					<div className="jumbotronFooter">
						<Row
							type="flex"
							justify="center"
							gutter={[16, 16]}
							style={{ padding: '1rem' }}
						>
							<Col md={8} xs={12}>
								<Input
									prefix={<SearchOutlined />}
									placeholder={'Search Job Title'}
									type="text"
									allowClear
									name="searchJobTitle"
									value={searchInputs.title}
									onChange={onSearchChange}
								/>
							</Col>
							<Col md={8} xs={12}>
								<Select
									// multiple selection
									mode="multiple"
									style={{ width: '100%' }}
									prefix={<SearchOutlined />}
									placeholder={'Search Company Name'}
									name="searchCoyName"
									// indicates to user there are options
									showArrow
									// shows max 2 options
									defaultValue={selectedCoyId}
									maxTagCount={2}
									onChange={selectOption}
									filterOption={(input, option) =>
										option.children
											.toLowerCase()
											.indexOf(input.toLowerCase()) >= 0
									}
								>
									{coyName.map(({ id, name }) => {
										return (
											<Option key={id} value={id}>
												{name}
											</Option>
										)
									})}
								</Select>
							</Col>
						</Row>
					</div>
				</div>
				<Tabs
					type="card"
					style={{ margin: '-56px 0', textAlign: 'center', paddingBottom: '3rem' }}
					defaultActiveKey={isActive === true ? '1' : '2'}
					onChange={handleChangeTab}
				>
					<TabPane
						tab={
							<div>
								{'Active Jobs'}
								<Badge
									count={activeCount}
									style={{ top: '-0.5rem', right: '-0.5rem' }}
								/>
							</div>
						}
						key="1"
					>
						<>{isActive === true && <ShowJobs isActive />}</>
					</TabPane>
					<TabPane
						tab={
							<div>
								{'Inactive Jobs'}
								<Badge
									count={inactiveCount}
									style={{ top: '-0.5rem', right: '-0.5rem' }}
								/>
							</div>
						}
						key="2"
					>
						<>{isActive === false && <ShowJobs isActive={false} />}</>
					</TabPane>
				</Tabs>
			</ApolloProvider>
			<Modal
				title="Contact Us"
				visible={isModalVisible}
				onCancel={() => setIsModalVisible(false)}
				// closable={false}
				footer={null}
			>
				<p>
          Start posting jobs on our platform!
					<br />
          Contact us for more information
				</p>
				<p>
					<MailTwoTone />
          &nbsp;&nbsp;sales@findjobs.com.sg
				</p>
				<p>
					<PhoneTwoTone />
          &nbsp;&nbsp;6916 4240
				</p>
			</Modal>
		</>
	)
}

export default JobList
